// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../../DatePickerTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DatePickerProvider-module__Container__HQssZ {
    display: flex;
    gap: var(--ds-s);
    background: var(--ds-date-picker-container-bg-color);
    border: var(--ds-border-width) solid
        var(--ds-date-picker-container-border-color);
    border-radius: var(--ds-border-radius-m);
    box-shadow: 0 0 var(--ds-blur-24)
        var(--ds-date-picker-container-box-shadow-color);
    backdrop-filter: blur(var(--ds-blur-24));
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `DatePickerProvider-module__Container__HQssZ`
};
export default ___CSS_LOADER_EXPORT___;
